import { render, staticRenderFns } from "./OneLeaveMenuPage.vue?vue&type=template&id=61e98ec0&scoped=true&"
import script from "./OneLeaveMenuPage.vue?vue&type=script&lang=js&"
export * from "./OneLeaveMenuPage.vue?vue&type=script&lang=js&"
import style0 from "./OneLeaveMenuPage.vue?vue&type=style&index=0&id=61e98ec0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e98ec0",
  null
  
)

export default component.exports